import { CloseRounded } from "@mui/icons-material";
import { Modal } from "@mui/material";

import {
  Container,
  Title,
  Wrapper,
  Image,
  Desc,
  KeyPoint,
} from "./ExtracurricularDetailsStyles";
import { StyledLink } from "../CommonStyles/Styles";

const ExtracurricularDetails = ({
  openModalExtracurricular,
  setOpenModalExtracurricular,
}) => {
  const project = openModalExtracurricular?.project;

  return (
    <Modal
      open={true}
      onClose={(_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          setOpenModalExtracurricular({ state: false, project: null });
        }
      }}
    >
      <Container>
        <Wrapper>
          <CloseRounded
            style={{
              position: "absolute",
              top: "10px",
              right: "20px",
              cursor: "pointer",
            }}
            onClick={() =>
              setOpenModalExtracurricular({ state: false, project: null })
            }
          />
          <Image src={project?.image} />
          <Title>{project?.title}</Title>
          <Desc>{project?.description}</Desc>
          <KeyPoint>
            {project?.link ? (
              <>
                <b>Link: </b>
                <StyledLink target="new" href={project.link}>
                  {project.link}
                </StyledLink>
              </>
            ) : null}
          </KeyPoint>
          <KeyPoint>
            {project?.credentials ? (
              <>
                <b>Credentials: </b>
                {project.credentials}
              </>
            ) : null}
          </KeyPoint>
        </Wrapper>
      </Container>
    </Modal>
  );
};

export default ExtracurricularDetails;
